<div class="global-spinner__wrapper">
    <app-spinner [title]="title"></app-spinner>
</div>
